import React from 'react';
import { Image, ImageStyle } from 'react-native';

import { makeStyles } from '@providers/Theme';

type LogoProps = {
  width?: number;
  height?: number;
  marginLeft?: number;
  testID?: string;
};

const useStyles = makeStyles<LogoProps>(() => ({
  root: (props) => ({
    width: props.width,
    height: props.height,
    marginLeft: props.marginLeft,
  }),
}));

export const Elmenus: React.FC<LogoProps> = (props) => {
  const styles = useStyles(props);
  return (
    <Image
      source={require('./assets/elmenus.png')}
      style={styles.root as ImageStyle}
      testID={props.testID}
    />
  );
};
